import {Building} from "@game/coregame/ecs/entities/Building";
import {color, math} from "@game/coregame/helpers";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {Vector2} from "@game/coregame/interfaces/Vector2";
import {GameColors, getFightersSpeedPreset} from "@game/coregame/settings";
import {inject, injectable} from "inversify";
import {FighterGroup} from "@game/coregame/view/FighterGroup";
import {Entity} from "tick-knock";
import {CookieModel} from "@game/coregame/model/CookieModel";
import {TypesGame} from "@game/TypesGame";

const fighterPreset = getFightersSpeedPreset();

@injectable()
export class Fighter extends Entity {
    static readonly TAG = "fighter";
    static readonly TAG_DIED = "fighter_died";
    static readonly DEFAULT_SIZE = fighterPreset.DEFAULT_SIZE;
    static readonly NORMAL_SPEED = fighterPreset.NORMAL_SPEED;
    static readonly DISTANCE_TOLERANCE = 0.5;
    public readonly color: number = 0xff0000;
    public readonly position: Vector2 = [0, 0];
    private _rotation = 0;
    public group?: FighterGroup;

    @inject(TypesGame.cookieModel)
    private cookies: CookieModel;

    constructor(
        public readonly owner: PlayerType,
        public readonly source: Building,
        public readonly target: Building,
        public readonly step: float,
        private readonly path: Vector2[],
        public readonly amount: int,
        private readonly speed: float,
        public readonly scaleFactor: float = 1
    ) {
        super();
        const [, unit] = GameColors.players[owner];
        this.color = color.fromHex(unit);
        this.add(Fighter.TAG);
    }
    public getPositionOnGrid(cellSize = 100): Vector2 {
        const [x, y] = this.position;
        return [Math.round(x / cellSize), Math.round(y / cellSize)] as Vector2;
    }
    public move(dt = 0): boolean {
        const wayPoint = this.path[0];
        if (!wayPoint) {
            return true;
        }
        const [wx, wy] = wayPoint;
        let [x, y] = this.position;
        const a = Math.atan2(wy - y, wx - x);
        const unitSize = Fighter.DEFAULT_SIZE; // / this.scaleFactor;
        x += (Math.cos(a) * this.speed * dt) / unitSize;
        y += (Math.sin(a) * this.speed * dt) / unitSize;

        // var zRotation =  Mathf.Atan2(dir.y, dir.x) * Mathf.Rad2Deg;
        // var rotation = Quaternion.Slerp(transform.rotation, Quaternion.Euler(0.0f, 0.0f, zRotation), RotationSpeed * DeltaTime);

        this.position[0] = x;
        this.position[1] = y;
        this._rotation = a + Math.PI / 2;

        if (this.path.length > 0) {
            const scale = 30; // transform.localScale.x;
            if (math.dist(this.position, wayPoint) <= Fighter.DISTANCE_TOLERANCE * scale) {
                this.path.shift();
            }
        }

        return this.path.length == 0;
    }
    get rotation(): number {
        return this._rotation;
    }
}
